module.exports = __webpack_public_path__ + "static/assets/b161adf32371e1f4a1f1650cb9bc5b80.png";